import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  Renderer2,
  OnChanges,
  OnDestroy,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';

@Component({
  selector: 'vb-btn-before-action',
  templateUrl: './btn-before-action.component.html',
  styleUrls: ['./btn-before-action.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BtnBeforeActionComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class BtnBeforeActionComponent implements OnInit, OnChanges, OnDestroy {
  private renderer = inject(Renderer2);
  private store = inject(Store);
  private elementRef = inject(ElementRef);

  @Input() element: any;
  @Input() currentScreen: any;
  @Input() disableField = false;
  @Input() formData: any;
  @Input() isFromModernize = false;
  private modelValue: any;
  private onChange: (m: any) => void = () => {};
  private onTouched: (m: any) => void = () => {};
  disabled: boolean;
  selectedAction: any;
  currentTableId: any;
  actions: any[] = [];
  previousAction = '';

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setSelectedValue(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange?.(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  setSelectedValue(value) {
    if (value) {
      this.selectedAction = value;
    }
  }

  handleChange(event: any) {
    this.modelValue = event.value;
    this.onChange(this.modelValue);
  }

  loadActions() {
    console.log(this.element);
    console.log(this.currentScreen);
    this.actions = [
      {
        name: 'None',
        value: 'none'
      },
      {
        name: 'Show confirmation',
        value: 'show_confirmation'
      },
      {
        name: 'Get additional info',
        value: 'get_additional_info'
      },
      {
        name: 'Custom',
        value: 'custom'
      }
    ];
  }

  ngOnInit(): void {
    this.previousAction = this.formData.action;
    this.currentTableId = this.currentScreen.tableId;
    this.loadActions();
    this.manipulatebeforeAction();
  }

  ngOnChanges(): void {
    if (this.previousAction !== this.formData.action && this.previousAction !== '') {
      this.manipulatebeforeAction();
    }
  }

  manipulatebeforeAction() {
    const action = this.formData.action;
    let bAction: string = this.formData.beforeAction;
    this.loadActions();
    switch (action) {
      case 'back':
      case 'workflowhistory':
      case 'refresh':
      case 'changelog':
      case 'save':
      case 'export':
      case 'import':
      case 'new':
      case 'navigate_to_page':
        bAction = 'none';
        this.disableField = true;
        break;
      case 'delete':
      case 'cancel':
        bAction = 'show_confirmation';
        this.disableField = true;
        break;
      case 'call_a_backend_webservice':
      case 'save_and_close':
        if (this.formData.wfAction) {
          bAction = 'show_confirmation';
          this.disableField = false;
        } else {
          this.disableField = false;
        }
        break;
      case 'workflowtimeline':
      case 'workflowinstance':
        this.disableField = true;
        break;
      default:
        this.actions = this.actions.filter(a => a.value !== 'get_additional_info');
        if (bAction === 'get_additional_info') {
          bAction = 'none';
        }
        this.disableField = false;
    }
    if (this.isFromModernize) {
      this.disableField = true;
    }

    this.setSelectedValue(bAction);
    this.set(bAction);
    this.previousAction = this.formData.action;
  }

  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
  }
}
